(function () {
  "use strict";

  var t = {
    459: function _(t, e, n) {
      var r = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (i, o) {
          function a(t) {
            try {
              c(r.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              c(r.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function c(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(a, s);
          }

          c((r = r.apply(t, e || [])).next());
        });
      },
          i = this && this.__generator || function (t, e) {
        var n,
            r,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], r = 0;
                } finally {
                  n = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o = n(674),
          a = n(64),
          s = n(517),
          c = function () {
        function t(t) {
          this.client = t;
        }

        return t.prototype.generateBlock = function (t) {
          return r(this, void 0, void 0, function () {
            return i(this, function (e) {
              if (!(0, s.isNumber)(t)) throw new TypeError("First argument should be a number");
              return [2, this.client.getMethod("generateBlock")(t)];
            });
          });
        }, t.prototype.getBlockByHash = function (t, e) {
          return void 0 === e && (e = !1), r(this, void 0, void 0, function () {
            var n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!(0, s.isString)(t)) throw new TypeError("Block hash should be a string");
                  if (!(0, s.isBoolean)(e)) throw new TypeError("Second parameter should be boolean");
                  return [4, this.client.getMethod("getBlockByHash")(t, e)];

                case 1:
                  return n = r.sent(), this.client.assertValidBlock(n), [2, n];
              }
            });
          });
        }, t.prototype.getBlockByNumber = function (t, e) {
          return void 0 === e && (e = !1), r(this, void 0, void 0, function () {
            var n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!(0, s.isNumber)(t)) throw new TypeError("Invalid Block number");
                  if (!(0, s.isBoolean)(e)) throw new TypeError("Second parameter should be boolean");
                  return [4, this.client.getMethod("getBlockByNumber")(t, e)];

                case 1:
                  return n = r.sent(), this.client.assertValidBlock(n), [2, n];
              }
            });
          });
        }, t.prototype.getBlockHeight = function () {
          return r(this, void 0, void 0, function () {
            var t;
            return i(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.client.getMethod("getBlockHeight")()];

                case 1:
                  if (t = e.sent(), !(0, s.isNumber)(t)) throw new o.InvalidProviderResponseError("Provider returned an invalid block height");
                  return [2, t];
              }
            });
          });
        }, t.prototype.getTransactionByHash = function (t) {
          return r(this, void 0, void 0, function () {
            var e;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!(0, s.isString)(t)) throw new TypeError("Transaction hash should be a string");
                  return [4, this.client.getMethod("getTransactionByHash")(t)];

                case 1:
                  if (e = n.sent()) try {
                    return this.client.assertValidTransaction(e), [2, e];
                  } catch (t) {
                    return this.client.assertValidTransaction(e.tx), [2, e.tx];
                  }
                  return [2, e];
              }
            });
          });
        }, t.prototype.getBalance = function (t) {
          return r(this, void 0, void 0, function () {
            var e;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("getBalance")(t)];

                case 1:
                  if (e = n.sent(), !a.BigNumber.isBigNumber(e)) throw new o.InvalidProviderResponseError("Provider returned an invalid response");
                  return [2, e];
              }
            });
          });
        }, t.prototype.sendTransaction = function (t) {
          return r(this, void 0, void 0, function () {
            var e;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("sendTransaction")(t)];

                case 1:
                  e = n.sent();

                  try {
                    return this.client.assertValidTransaction(e), [2, e];
                  } catch (t) {
                    return this.client.assertValidTransaction(e.tx), [2, e.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.sendSweepTransaction = function (t, e) {
          return r(this, void 0, void 0, function () {
            return i(this, function (n) {
              return [2, this.client.getMethod("sendSweepTransaction")(t, e)];
            });
          });
        }, t.prototype.updateTransactionFee = function (t, e) {
          return r(this, void 0, void 0, function () {
            var n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  if ((0, s.isObject)(t)) this.client.assertValidTransaction(t);else if (!(0, s.isString)(t)) throw new TypeError("Transaction should be a string or object");
                  return [4, this.client.getMethod("updateTransactionFee")(t, e)];

                case 1:
                  n = r.sent();

                  try {
                    return this.client.assertValidTransaction(n), [2, n];
                  } catch (t) {
                    return this.client.assertValidTransaction(n.tx), [2, n.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.sendBatchTransaction = function (t) {
          return r(this, void 0, void 0, function () {
            return i(this, function (e) {
              return [2, this.client.getMethod("sendBatchTransaction")(t)];
            });
          });
        }, t.prototype.sendRawTransaction = function (t) {
          return r(this, void 0, void 0, function () {
            var e;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("sendRawTransaction")(t)];

                case 1:
                  if (e = n.sent(), !(0, s.isString)(e)) throw new o.InvalidProviderResponseError("sendRawTransaction method should return a transaction id string");
                  return [2, e];
              }
            });
          });
        }, t.prototype.getFees = function () {
          return r(this, void 0, void 0, function () {
            return i(this, function (t) {
              return [2, this.client.getMethod("getFees")()];
            });
          });
        }, t;
      }();

      e.default = c;
    },
    231: function _(t, e, n) {
      var r = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var i = n(356),
          o = n(674),
          a = n(517),
          s = r(n(974)),
          c = r(n(888)),
          u = r(n(459)),
          l = r(n(384)),
          h = r(n(413)),
          d = r(n(568)),
          f = function () {
        function t(t, e) {
          this._providers = [], this.version = e, t && this.addProvider(t);
          var n = new c.default();
          this.validateTransaction = n.compile(i.Transaction), this.validateBlock = n.compile(i.Block), this._chain = new u.default(this), this._wallet = new l.default(this), this._swap = new h.default(this), this._nft = new d.default(this);
        }

        return t.debug = function (t) {
          void 0 === t && (t = "*"), s.default.load() || s.default.enable(t);
        }, t.prototype.addProvider = function (t) {
          if (!(0, a.isFunction)(t.setClient)) throw new o.InvalidProviderError('Provider should have "setClient" method');
          if ((0, a.find)(this._providers, function (e) {
            return t.constructor === e.constructor;
          })) throw new o.DuplicateProviderError("Duplicate provider");
          return t.setClient(this), this._providers.push(t), this;
        }, t.prototype.getProviderForMethod = function (t, e) {
          if (void 0 === e && (e = !1), 0 === this._providers.length) throw new o.NoProviderError("No provider provided. Add a provider to the client");
          var n = e ? (0, a.findLastIndex)(this._providers, function (t) {
            return e.constructor === t.constructor;
          }) : this._providers.length;
          -1 === n && (n = 0);
          var r = (0, a.findLast)(this._providers, function (e) {
            return (0, a.isFunction)(e[t]);
          }, n - 1);
          if (null == r) throw new o.UnimplementedMethodError('Unimplemented method "'.concat(t, '"'));
          if ((0, a.isFunction)(r._checkMethodVersionSupport) && !r._checkMethodVersionSupport(t, this.version)) throw new o.UnsupportedMethodError('Method "'.concat(t, '" is not supported by version "').concat(this.version, '"'));
          return r;
        }, t.prototype.getMethod = function (t, e) {
          var n = this.getProviderForMethod(t, e);
          return n[t].bind(n);
        }, t.prototype.assertValidTransaction = function (t) {
          if (!this.validateTransaction(t)) {
            var e = this.validateTransaction.errors;
            throw new o.InvalidProviderResponseError('Provider returned an invalid transaction, "'.concat(e[0].dataPath, '" ').concat(e[0].message));
          }
        }, t.prototype.assertValidBlock = function (t) {
          if (!this.validateBlock(t)) {
            var e = this.validateBlock.errors;
            throw new o.InvalidProviderResponseError('Provider returned an invalid block, "'.concat(e[0].dataPath, '" ').concat(e[0].message));
          }
        }, Object.defineProperty(t.prototype, "chain", {
          get: function get() {
            return this._chain;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "wallet", {
          get: function get() {
            return this._wallet;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "swap", {
          get: function get() {
            return this._swap;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "nft", {
          get: function get() {
            return this._nft;
          },
          enumerable: !1,
          configurable: !0
        }), t;
      }();

      e.default = f;
    },
    568: function _(t, e) {
      var n = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (i, o) {
          function a(t) {
            try {
              c(r.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              c(r.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function c(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(a, s);
          }

          c((r = r.apply(t, e || [])).next());
        });
      },
          r = this && this.__generator || function (t, e) {
        var n,
            r,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], r = 0;
                } finally {
                  n = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var i = function () {
        function t(t) {
          this.client = t;
        }

        return t.prototype.balance = function (t, e) {
          return n(this, void 0, void 0, function () {
            return r(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("balance")(t, e)];

                case 1:
                  return [2, n.sent()];
              }
            });
          });
        }, t.prototype.transfer = function (t, e, i, o, a) {
          return n(this, void 0, void 0, function () {
            var n;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.client.getMethod("transfer")(t, e, i, o, a)];

                case 1:
                  n = r.sent();

                  try {
                    return this.client.assertValidTransaction(n), [2, n];
                  } catch (t) {
                    return this.client.assertValidTransaction(n.tx), [2, n.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.approve = function (t, e, i) {
          return n(this, void 0, void 0, function () {
            var n;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.client.getMethod("approve")(t, e, i)];

                case 1:
                  n = r.sent();

                  try {
                    return this.client.assertValidTransaction(n), [2, n];
                  } catch (t) {
                    return this.client.assertValidTransaction(n.tx), [2, n.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.isApproved = function (t, e) {
          return n(this, void 0, void 0, function () {
            return r(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("isApproved")(t, e)];

                case 1:
                  return [2, n.sent()];
              }
            });
          });
        }, t.prototype.approveAll = function (t, e, i) {
          return n(this, void 0, void 0, function () {
            var n;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.client.getMethod("approveAll")(t, e, i)];

                case 1:
                  n = r.sent();

                  try {
                    return this.client.assertValidTransaction(n), [2, n];
                  } catch (t) {
                    return this.client.assertValidTransaction(n.tx), [2, n.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.isApprovedForAll = function (t, e) {
          return n(this, void 0, void 0, function () {
            return r(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.client.getMethod("isApprovedForAll")(t, e)];

                case 1:
                  return [2, n.sent()];
              }
            });
          });
        }, t.prototype.fetch = function () {
          return n(this, void 0, void 0, function () {
            return r(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.client.getMethod("fetch")()];

                case 1:
                  return [2, t.sent()];
              }
            });
          });
        }, t;
      }();

      e.default = i;
    },
    413: function _(t, e, n) {
      var r = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (i, o) {
          function a(t) {
            try {
              c(r.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              c(r.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function c(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(a, s);
          }

          c((r = r.apply(t, e || [])).next());
        });
      },
          i = this && this.__generator || function (t, e) {
        var n,
            r,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], r = 0;
                } finally {
                  n = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o = n(238),
          a = n(674),
          s = function () {
        function t(t) {
          this.client = t;
        }

        return t.prototype.findInitiateSwapTransaction = function (t, e) {
          return r(this, void 0, void 0, function () {
            return i(this, function (n) {
              return [2, this.client.getMethod("findInitiateSwapTransaction")(t, e)];
            });
          });
        }, t.prototype.findClaimSwapTransaction = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            return i(this, function (r) {
              return [2, this.client.getMethod("findClaimSwapTransaction")(t, e, n)];
            });
          });
        }, t.prototype.findRefundSwapTransaction = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            return i(this, function (r) {
              return [2, this.client.getMethod("findRefundSwapTransaction")(t, e, n)];
            });
          });
        }, t.prototype.findFundSwapTransaction = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            return i(this, function (r) {
              return [2, this.client.getMethod("findFundSwapTransaction")(t, e, n)];
            });
          });
        }, t.prototype.generateSecret = function (t) {
          return r(this, void 0, void 0, function () {
            var e, n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  try {
                    return [2, this.client.getMethod("generateSecret")(t)];
                  } catch (t) {
                    if (!(t instanceof a.UnimplementedMethodError)) throw t;
                  }

                  return [4, this.client.getMethod("getAddresses")()];

                case 1:
                  return e = r.sent()[0], [4, this.client.getMethod("signMessage")(t, e.address)];

                case 2:
                  return n = r.sent(), [2, (0, o.sha256)(n)];
              }
            });
          });
        }, t.prototype.getSwapSecret = function (t) {
          return r(this, void 0, void 0, function () {
            return i(this, function (e) {
              return [2, this.client.getMethod("getSwapSecret")(t)];
            });
          });
        }, t.prototype.initiateSwap = function (t, e) {
          return r(this, void 0, void 0, function () {
            var n;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.client.getMethod("initiateSwap")(t, e)];

                case 1:
                  n = r.sent();

                  try {
                    return this.client.assertValidTransaction(n), [2, n];
                  } catch (t) {
                    return this.client.assertValidTransaction(n.tx), [2, n.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.fundSwap = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            return i(this, function (r) {
              return [2, this.client.getMethod("fundSwap")(t, e, n)];
            });
          });
        }, t.prototype.verifyInitiateSwapTransaction = function (t, e) {
          return this.client.getMethod("verifyInitiateSwapTransaction")(t, e);
        }, t.prototype.claimSwap = function (t, e, n, o) {
          return r(this, void 0, void 0, function () {
            var r;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!/[A-Fa-f0-9]{64}/.test(n)) throw new TypeError("Secret should be a 32 byte hex string");
                  return [4, this.client.getMethod("claimSwap")(t, e, n, o)];

                case 1:
                  r = i.sent();

                  try {
                    return this.client.assertValidTransaction(r), [2, r];
                  } catch (t) {
                    return this.client.assertValidTransaction(r.tx), [2, r.tx];
                  }

                  return [2];
              }
            });
          });
        }, t.prototype.refundSwap = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            var r;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.client.getMethod("refundSwap")(t, e, n)];

                case 1:
                  r = i.sent();

                  try {
                    return this.client.assertValidTransaction(r), [2, r];
                  } catch (t) {
                    return this.client.assertValidTransaction(r.tx), [2, r.tx];
                  }

                  return [2];
              }
            });
          });
        }, Object.defineProperty(t.prototype, "doesBlockScan", {
          get: function get() {
            try {
              return this.client.getMethod("doesBlockScan")();
            } catch (t) {
              if (!(t instanceof a.UnimplementedMethodError)) throw t;
            }

            return !0;
          },
          enumerable: !1,
          configurable: !0
        }), t;
      }();

      e.default = s;
    },
    384: function _(t, e, n) {
      var r = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (i, o) {
          function a(t) {
            try {
              c(r.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              c(r.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function c(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(a, s);
          }

          c((r = r.apply(t, e || [])).next());
        });
      },
          i = this && this.__generator || function (t, e) {
        var n,
            r,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], r = 0;
                } finally {
                  n = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o = n(674),
          a = n(517),
          s = function () {
        function t(t) {
          this.client = t;
        }

        return t.prototype.getAddresses = function (t, e, n) {
          return r(this, void 0, void 0, function () {
            var r;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.client.getMethod("getAddresses")(t, e, n)];

                case 1:
                  if (r = i.sent(), !(0, a.isArray)(r)) throw new o.InvalidProviderResponseError("Provider returned an invalid response");
                  return [2, r];
              }
            });
          });
        }, t.prototype.getUsedAddresses = function (t) {
          return r(this, void 0, void 0, function () {
            return i(this, function (e) {
              return [2, this.client.getMethod("getUsedAddresses")(t)];
            });
          });
        }, t.prototype.getUnusedAddress = function (t, e) {
          return r(this, void 0, void 0, function () {
            return i(this, function (n) {
              return [2, this.client.getMethod("getUnusedAddress")(t, e)];
            });
          });
        }, t.prototype.signMessage = function (t, e) {
          return r(this, void 0, void 0, function () {
            return i(this, function (n) {
              return [2, this.client.getMethod("signMessage")(t, e)];
            });
          });
        }, t.prototype.getConnectedNetwork = function () {
          return r(this, void 0, void 0, function () {
            return i(this, function (t) {
              return [2, this.client.getMethod("getConnectedNetwork")()];
            });
          });
        }, t.prototype.isWalletAvailable = function () {
          return r(this, void 0, void 0, function () {
            return i(this, function (t) {
              return [2, this.client.getMethod("isWalletAvailable")()];
            });
          });
        }, Object.defineProperty(t.prototype, "canUpdateFee", {
          get: function get() {
            try {
              return this.client.getMethod("canUpdateFee")();
            } catch (t) {
              if (!(t instanceof o.UnimplementedMethodError)) throw t;
            }

            return !0;
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.exportPrivateKey = function () {
          return this.client.getMethod("exportPrivateKey")();
        }, t;
      }();

      e.default = s;
    },
    175: function _(t, e, n) {
      var r = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.Client = void 0;
      var i = r(n(231));
      e.Client = i.default;
    },
    238: function _(t) {
      t.exports = require("@yaswap/crypto");
    },
    674: function _(t) {
      t.exports = require("@yaswap/errors");
    },
    356: function _(t) {
      t.exports = require("@yaswap/schema");
    },
    64: function _(t) {
      t.exports = require("@yaswap/types");
    },
    888: function _(t) {
      t.exports = require("ajv");
    },
    974: function _(t) {
      t.exports = require("debug");
    },
    517: function _(t) {
      t.exports = require("lodash");
    }
  },
      e = {},
      n = function n(r) {
    var i = e[r];
    if (void 0 !== i) return i.exports;
    var o = e[r] = {
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.exports;
  }(175);

  module.exports = n;
})();